import { motion } from "framer-motion";

const PORTRAIT = "/founder.png";

const credentials = ["CMA", "CPA Candidate", "FP&A", "QuickBooks ProAdvisor", "Six Sigma Green Belt", "Power BI", "SQL · Python", "15 ChatGPT Tips for Everyday Data Analysis — LinkedIn Learning"];

const timeline = [
  { years: "2025 — Today", role: "Founder & Fractional CFO", org: "BookCare LLC", note: "Fractional CFO and controller for nonprofit and for-profit clients; led a Single Audit to an unmodified opinion under OMB 2 CFR 200." },
];

export default function Founder() {
  return (
    <section id="about" data-testid="about-section" className="border-t border-linen bg-white/40">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-6 py-28 md:grid-cols-12 md:px-10 md:py-40">
        <div className="md:col-span-5">
          <div className="md:sticky md:top-32">
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
              className="mb-6 font-mono text-[11px] uppercase tracking-[0.35em] text-terra"
            >
              The Founder
            </motion.p>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
              className="mb-8 font-serif text-4xl font-medium leading-tight tracking-tight text-pine md:text-5xl"
              data-testid="about-heading"
            >
              Zecharias A. <span className="italic text-forest">Mesgane</span>
            </motion.h2>
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
              className="mb-8 mx-auto w-64 md:w-72 md:mx-0"
            >
              <img
                src={PORTRAIT}
                alt="Zecharias A. Mesgane, Founder of BookCare LLC"
                data-testid="founder-portrait"
                className="aspect-square w-full rounded-full border-2 border-forest/20 object-contain shadow-lg"
              />
            </motion.div>
            <p className="mb-6 text-sm leading-relaxed text-pine/70" data-testid="founder-bio">
              A results-driven CFO with 16+ years across nonprofit, healthcare, and for-profit
              finance — from FQHC grant compliance and HRSA reporting to board-level strategy.
              He built his own path to the CFO chair and now helps other finance professionals
              do the same.
            </p>
            <div className="flex flex-wrap gap-2" data-testid="founder-credentials">
              {credentials.map((c) => (
                <span key={c} className="border border-forest/30 px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.15em] text-forest">
                  {c}
                </span>
              ))}
            </div>
          </div>
        </div>
        <div className="md:col-span-7">
          <p className="mb-12 font-mono text-[11px] uppercase tracking-[0.35em] text-pine/50" data-testid="timeline-label">
            A 16-year ledger of leadership
          </p>
          <div className="border-l border-linen">
            {timeline.map((t, i) => (
              <motion.div
                key={t.org}
                initial={{ opacity: 0, x: 40 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
                className="group relative border-b border-linen py-10 pl-10"
                data-testid={`timeline-item-${i}`}
              >
                <span className="absolute -left-[5px] top-12 h-2.5 w-2.5 rounded-full bg-terra" />
                {t.years && <p className="mb-2 font-mono text-xs tracking-[0.2em] text-terra">{t.years}</p>}
                <h3 className="font-serif text-2xl font-semibold tracking-tight text-pine">{t.role}</h3>
                <p className="mb-3 font-mono text-[11px] uppercase tracking-[0.2em] text-forest">{t.org}</p>
                <p className="max-w-xl text-sm leading-relaxed text-pine/70">{t.note}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
